module.exports = __webpack_public_path__ + "static/img/2.47b5f69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/zh/2.png
// module id = nw2L
// module chunks = 0